export const getMyConversationUrl = (conversationId?: string | null): string => {
  /** If there is no conversation ID - fallback to "my messages" page */
  if (!conversationId) return '/m-msg-my-messages.html'

  return `/m-msg-my-messages/conversation/${conversationId}`
}
